export const toSmartQuotes = (value) => {
  if (!value) {
    return '';
  }

  let text = '';
  try {
    text = String(value);
  } catch (error) {
    return '';
  }

  const isWordChar = (char) => /[A-Za-z0-9]/.test(char || '');
  const getPrevNonSpaceChar = (source, startIndex) => {
    for (let index = startIndex; index >= 0; index -= 1) {
      if (!/\s/.test(source[index])) {
        return source[index];
      }
    }
    return '';
  };

  const getNextNonSpaceChar = (source, startIndex) => {
    for (let index = startIndex; index < source.length; index += 1) {
      if (!/\s/.test(source[index])) {
        return source[index];
      }
    }
    return '';
  };

  const openingBoundaryPattern = /[\s([{<]/;
  const closingBoundaryPattern = /[\s)\]}>,.!?:;]/;
  const leadingElisionPattern = /^(?:em|til|tis|twas|twere|ere|cause|cuz|round|nuff)\b/i;
  let expectOpeningSingle = true;
  let expectOpeningDouble = true;

  return text
    .split('')
    .map((char, index) => {
      if (char !== "'" && char !== '"') {
        return char;
      }

      const prevChar = getPrevNonSpaceChar(text, index - 1);
      const nextChar = getNextNonSpaceChar(text, index + 1);

      if (char === "'") {
        if (isWordChar(prevChar) && isWordChar(nextChar)) {
          return '\u2019';
        }

        const isOpening = !prevChar || openingBoundaryPattern.test(prevChar);
        const isClosing = !nextChar || closingBoundaryPattern.test(nextChar);
        const nextTokenMatch = text.slice(index + 1).match(/^[A-Za-z0-9]+/);
        const nextToken = nextTokenMatch ? nextTokenMatch[0] : '';

        if (isOpening && (/\d/.test(nextChar) || leadingElisionPattern.test(nextToken))) {
          return '\u2019';
        }

        if (isOpening && !isClosing) {
          expectOpeningSingle = false;
          return '\u2018';
        }

        if (!isOpening && isClosing) {
          expectOpeningSingle = true;
          return '\u2019';
        }

        const replacement = expectOpeningSingle ? '\u2018' : '\u2019';
        expectOpeningSingle = !expectOpeningSingle;
        return replacement;
      }

      const isOpening = !prevChar || openingBoundaryPattern.test(prevChar);
      const isClosing = !nextChar || closingBoundaryPattern.test(nextChar);

      if (isOpening && !isClosing) {
        expectOpeningDouble = false;
        return '\u201c';
      }

      if (!isOpening && isClosing) {
        expectOpeningDouble = true;
        return '\u201d';
      }

      const replacement = expectOpeningDouble ? '\u201c' : '\u201d';
      expectOpeningDouble = !expectOpeningDouble;
      return replacement;
    })
    .join('');
};
